export function assertFailed(message) {
    throw Error("Assert failed: " + message);
}
export function assertNot(condition, message) {
    assert(!condition, message);
}
export function assert(condition, message) {
    if (condition) {
        return;
    }
    assertFailed(message);
}
//# sourceMappingURL=assert.js.map